const strings = {
	quantityShouldBeGreatherThenProductMin:
		"Quantidade deve ser maior que a quantidade miníma do produto",
	reason: "Motivo",
	appName: "DUES",
	about: "Sobre",
	home: "Início",
	queue: "Fila",
	table: "Mesa",
	tables: "Mesas",
	booking: "Reserva",
	reports: "Relatórios",
	queues: "Filas",
	features: "Recursos",
	download: "Baixar",
	places: "Lugares",
	contact: "Contato",
	description: "Descrição",
	new: "Novo",
	called: "Chamado",
	done: "Finalizado",
	doneBooking: "Reservas finalizadas",
	canceledOrRejectBooking: "Reservas canceladas ou rejeitadas",
	canceled: "Cancelado",
	yes: "Sim",
	no: "Não",
	name: "Nome",
	email: "E-mail",
	emailHistory: "Histórico de e-mails",
	emailPlaceholder: "joaosilva@gmail.com",
	namePlaceholder: "João",
	lastName: "Sobrenome",
	lastNamePlaceholder: "Silva",
	Requested: "Solicitado",
	pendings: "Pendentes",
	pending: "Pendente",
	Pending: "Pendente",
	confirm: "Confirmar",
	reject: "Rejeitar",
	confirmed: "Confirmado",
	rejected: "Rejeitado",
	calleds: "Chamadas",
	subject: "Assunto",
	sendMessage: "Enviar",
	sendMessageSuccess: "Sucesso! Sua mensagem foi enviada",
	sendMessageError:
		"Oops! Ocorreu um erro ao tentar enviar sua mensagem, tente novamente",
	signUp: "Cadastrar",
	signIn: "Entrar",
	loginIn: "Entrar em",
	forgotPassword: "Esqueceu sua Senha",
	dontHaveAnAccount: "Não tem uma conta",
	required: "Obrigatório",
	clear: "Limpar",
	nextPassword: "Próxima senha",
	"Invalid email.": "E-mail não cadastrado",
	"Invalid password.": "Senha incorreta",
	number: "Número",
	invalid: "Inválido",
	qrCode: "QR Code",
	connect: "Conectar",
	readTheQrCodeInTheApp: "Leia o QRCode no Aplicativo",
	waitingTime: "Tempo de espera",
	minutes: "Minutos",
	people: "Pessoas",
	minPeople: "Mínimo de Pessoas",
	numberOfPeople: "Nº Pessoas",
	resetPassword: "Zerar senha",
	phoneNumber: "Telefone",
	cellPhone: "Celular",
	phoneNumberPlaceholder: "21 3456-7890",
	cellPhonePlaceholder: "21 3456-7890",
	status: "Status",
	WithinLimit: "Dentro do Limite",
	AtLimit: "No Limite",
	OverLimit: "Acima do Limite",
	maxLimit: "Limite Máximo",
	baseLimit: "Limite Base",
	remaining: "Restante/Excedido",
	notInformed: "Não informado",
	client: "Cliente",
	clients: "Clientes",
	noTable: "Nenhuma mesa",
	bookingNotConfirmed: "Reserva não confirmada",
	areYouSureYouWantToCallThisCustomer:
		"Tem certeza que deseja chamar este cliente",
	areYouSureYouWantToCancelThisQueue:
		"Tem certeza que deseja cancelar esta senha",
	areYouSureYouWantToCancelThisBooking:
		"Tem certeza que deseja cancelar esta reserva",
	areYouSureYouWantToFinishThisQueue:
		"Tem certeza que deseja finalizar esta senha",
	areYouSureYouWantToConfirmThisBooking:
		"Tem certeza que deseja confirmar esta reserva",
	areYouSureYouWantToFinishThisBooking:
		"Tem certeza que deseja finalizar esta reserva",
	areYouSureYouWantToRejectThisBooking:
		"Tem certeza que deseja rejeitar esta reserva",
	areYouSureYouWantToDeleteThisTable:
		"Tem certeza que deseja deletar esta mesa",
	ifYouContinueDeleteTableMessage:
		"Se você continuar, não será possível desfazer",
	ifYouContinueFinishQueueMessage:
		"Se você continuar, estará informando que o cliente já foi atendido",
	ifYouContinueFinishBookingMessage:
		"Se você continuar, estará informando que o cliente já foi atendido",
	areYouSure: "Você tem certeza",
	dateFormat: "DD/MM/YYYY - HH:mm:ss",
	dateFormatWithoutSeconds: "DD/MM/YYYY - HH:mm",
	dateFormatWithoutYearAndSeconds: "DD MMM - HH:mm",
	dateFormatShort: "DD/MM/YYYY",
	dateFormatMonth: "MM/YYYY",
	timeFormat: "HH:mm",
	yesCancel: "Sim, cancelar!",
	cancel: "Cancelar",
	conclude: "Concluir",
	finish: "Finalizar",
	list: "Lista",
	backToLogin: "Voltar para login",
	register: "Cadastrar",
	needCreateBusinessMessage:
		"Você precisa cadastrar uma nova empresa para continuar",
	recoverPassword: "Recuperar a senha",
	newPasswordSentForEmail: "Uma nova senha foi enviada para o e-mail informado",
	meiData: "Dados do MEI",
	companyData: "Dados da empresa",
	businessData: "Dados do estabelecimento",
	businessName: "Razão Social",
	socialName: "Nome fantasia",
	search: "Pesquisar",
	cnpj: "CNPJ",
	cpfOrCnpj: "CPF ou CNPJ",
	zipCode: "CEP",
	street: "Endereço",
	complement: "Complemento",
	neighborhood: "Bairro",
	city: "Cidade",
	state: "Estado",
	country: "País",
	save: "Salvar",
	invalidPhoneNumber: "Telefone inválido",
	invalidCnpj: "CNPJ inválido",
	createNewTable: "Criar nova mesa",
	numberOrName: "Número ou nome",
	schedules: "Horários",
	open: "Aberto",
	closed: "Fechado",
	actions: "Ações",
	close: "Fechar",
	dateTime: "Data e hora",
	info: "Informações",
	privateInfo: "Informações privadas",
	person: "Pessoa",
	requiredIfEmailNotInformed: "Obrigatório se o e-mail não for informado",
	requiredIfPhoneNotInformed: "Obrigatório se o telefone não for informado",
	dateNeedToBeAfterNow: "Data precisa ser depois de agora",
	today: "Hoje",
	tomorrow: "Amanhã",
	otherDays: "Outros dias",
	time: "Horário",
	reserved: "Reservada",
	reserves: "Reservas",
	edit: "Editar",
	oops: "Oops",
	address: "Endereço",
	visible: "Visível",
	backgroundColor: "Cor de fundo",
	creationDate: "Data criação",
	notDefined: "Não definido",
	categories: "Categorias",
	category: "Categoria",
	loading: "Carregando",
	users: "Usuários",
	role: "Função/Cargo",
	addUser: "Adicionar usuário",
	rolePlaceholder: "Selecione uma função/cargo",
	"Business Admin": "Administrador da Empresa",
	Manager: "Gerente",
	User: "Usuário",
	property: "Imóveis",
	title: "Título",
	linkText: "Link permanente",
	code: "Código",
	noneSelectedText: "Selecione uma opção",
	type: "Tipo",
	price: "Preço",
	rooms: "Quartos",
	suites: "Suites",
	vacancies: "Vagas",
	privateArea: "Área privada(m²)",
	totalArea: "Área total(m²)",
	incorporation: "Incorporação",
	leads: "Leads",
	source: "Fonte",
	requests: "Solicitações",
	requestCreate: "Criar solicitação",
	pulloutDate: "Data de requisição",
	returnalDate: "Data de devolução",
	selectADate: "Selecione uma data",
	range: "Faixa",
	Launch: "Lançamento",
	Construction: "Construção",
	New: "Novo",
	Used: "Usado",
	furnished: "Mobiliado",
	starDate: "Inicio",
	endDate: "Fim",
	dashboard: "Dashboard",
	properties: "Imóveis",
	propertyCreate: "Criar novo imóvel",
	propertyEdit: "Editar imóvel",
	releases: "Lançamentos",
	searchProperties: "Procurar imóveis",
	saleProperties: "Imóveis à venda",
	rentalProperties: "Imóveis para locação anual",
	seasonProperties: "Imóveis para locação de temporada",
	homeTitle: "Imóveis para alugar e comprar em Bombinhas, Porto Belo e Itapema",
	"Duplicated code": "Código duplicado",
	banners: "Banners",
	configurations: "Configurações",
	chatCode: "Código do chat",
	tawkCode: "Código do Tawk.to",
	facePixel: "Pixel do Facebook",
	facePixelCode: "Código do Pixel do Facebook",
	googleAnalytics: "Google Analytics",
	googleAnalyticsCode: "Código do Google Analytics",
	cubPrice: "Preço do CUB",
	cub: "CUB",
	cubPercentage: "Variação",
	cubMonth: "Mês",
	enrollment: "Matrícula",
	admissionDate: "Data de admissão",
	admissionDateShort: "Admissão",
	county: "Comarca",
	userCreate: "Criar novo usuário",
	capacity: "Lotação",
	birthDate: "Data de nascimento",
	single: "Solteiro(a)",
	married: "Cassado(a)",
	widowed: "Viúvo(a)",
	divorced: "Divorciado(a)",
	registeredPartnership: "Parceria registrada",
	maritalStatus: "Estado civil",
	rg: "RG",
	rgEmissor: "Emissor do RG",
	rgEmissorState: "Estado Emitido o RG",
	cpf: "CPF",
	bloodType: "Tipo sanguíneo",
	APlus: "A+",
	AMinus: "A-",
	BPlus: "B+",
	BMinus: "B-",
	OPlus: "O+",
	OMinus: "O-",
	ABPlus: "AB+",
	ABMinus: "AB-",
	nationality: "Nacionalidade",
	naturalness: "Naturalidade",
	motherName: "Nome da mãe",
	fatherName: "Nome do pai",
	male: "Masculino",
	female: "Feminino",
	other: "Outro",
	gender: "Sexo",
	workStatus: "Situação",
	active: "Ativo",
	pensioners: "Pensionista",
	extrajudicial: "Extrajudicial",
	dependent: "Dependente",
	retired: "Aposentado",
	userData: "Dados do usuário",
	birthdays: "Aniversariantes",
	products: "Produtos",
	product: "Produto",
	productCreate: "Cadastrar novo produto",
	id: "Identificador",
	qty: "Quantidade em Estoque",
	req_max_qty: "Quantidade Solicitável",
	min_qty: "Quantidade Mínima",
	products_below_threshold: "Produtos Abaixo do Mínimo",
	productsThreshold: "Produtos Abaixo do Mínimo",
	needed: "Necessário",
	amount: "Quantidade",
	requestData: "Dados da solicitação",
	markAsReturned: "Marcar como devolvido",
	created: "Criado",
	returned: "Devolvido",
	noMei: "Sem MEI",
	createMei: "Criar MEI",
	phoneNotValidated: "Telefone não validado",
	responsibleForAnotherBusinessError: "Já tem CNPJ",
	noGovBrAccount: "Sem conta GOV.BR",
	errorOnFinishe: "Erro ao criar mei",
	meiCreated: "Mei Criado",
	errorOnGetMei: "Erro ao buscar mei",
	invalidBirthDate: "Data nasc. inválida",
	bankBillets: "Boletos",
	bankBilletCreate: "Criar novo boleto",
	bankBilletEdit: "Editar boleto",
	bankBilletData: "Dados do boleto",
	paid: "Pago",
	value: "Valor",
	situation: "Situação",
	emissionDate: "Data de emissão",
	openingDate: "Data de abertura",
	dueDate: "Vencimento",
	enabled: "Ativo",
	disabled: "Desativado",
	due: "Vencido",
	notOpting: "Não optante",
	userStatus: "Status do usuário",
	admin: "Administrador",
	logisticOperator: "Operador Logístico",
	nfseController: "Controlador NFSe",
	parentOperator: "Empresa controladora",
	mei: "MEI",
	meiStatus: "Status do MEI",
	subscriptions: "Assinaturas",
	payer: "Pagador",
	user: "Usuário",
	subscriptionCreate: "Criar assinatura",
	subscriptionsPay: "Gerar boleto de assinaturas",
	suspended: "Suspenso",
	fired: "Desligado",
	Fired: "Desligado",
	subscriptionData: "Dados da assinatura",
	subscriptionEdit: "Editar assinatura",
	logisticOperatorStatus: "Status OL",
	None: "Nenhum",
	Enabled: "Habilitado",
	Actived: "Ativo",
	Inactive: "Inativo/Suspenso",
	plan: "Plano",
	paymentMethod: "Método de pagamento",
	firstPayment: "Primeiro pagamento",
	discount: "Desconto",
	installment: "Parcelas",
	installmentInterval: "Intervalo cobrança",
	contractors: "Contratantes",
	serviceProviders: "Prestadores de serviço",
	companies: "Empresas",
	meis: "MEI's",
	invoices: "Faturas",
	failed: "Falha",
	notPaid: "Não pago",
	statusMei: "Status MEI",
	clientData: "Dados do cliente",
	clientCreate: "Criar novo cliente",
	clientEdit: "Editar cliente",
	authTokens: "Tokens de acesso",
	authToken: "Token de acesso",
	revokeToken: "Revogar token",
	revokeTokenConfirm: "Tem certeza que deseja revogar este token? O acesso associado será encerrado.",
	addAuthToken: "Adicionar token",
	createToken: "Criar token",
	tokenCreatedCopyNow: "Token criado. Copie e guarde em local seguro — ele não será exibido novamente.",
	copy: "Copiar",
	copied: "Copiado",
	lastUsed: "Último uso",
	add: "Adicionar",
	charges: "Cobranças",
	paymentDate: "Data pagamento",
	bankStatus: "Status Conta Digital",
	NoAccount: "Sem conta",
	Created: "Criada",
	Deleted: "Excluida",
	startAt: "Começa em",
	sending: "Enviando",
	pushTitle: "Título",
	pushMessage: "Mensagem",
	action: "Ação",
	none: "Nenhuma",
	openExternalBrowser: "Abrir link no navegador",
	openInternalBrowser: "Abrir link no APP",
	bankStatus2: "Conta digital",
	noMessage: "Sem mensagem",
	sent: "Enviado",
	received: "Recebido",
	read: "Lido",
	noToken: "Sem token",
	transfer: "Transferência",
	transfers: "Transferências",
	Done: "Concluído",
	Failed: "Falhado",
	Canceled: "Cancelado",
	BankAccount: "Conta bancária",
	P2P: "Entre contas",
	nfse: "NFS-e",
	nfses: "Notas fiscal de serviço",
	Generated: "Gerado",
	Error: "Erro",
	occupation: "Ocupação",
	activity: "Atividade",
	startDate: "Data de início",
	createdAt: "Criado em",
	updatedAt: "Atualizado em",
	deletedAt: "Excluído em",
	deleted: "Excluído",
	sendAt: "Enviado em",
	invoicing: "Faturamento",
	Processing: "Processando",
	pdf: "PDF",
	xml: "XML",
	company: "Empresa",
	meiCreate: "Criar MEI",
	meiEdit: "Editar MEI",
	companyEdit: "Editar empresa",
	delivered: "Entregue",
	serviceValue: "Valor do serviço",
	productValue: "Valor do produto",
	year: "Ano",
	event: "Evento",
	receipt: "Recibo",
	TotalUsers: "Total de usuários",
	TotalMeis: "Total de MEIs",
	TotalUsersToday: "Total de usuários hoje",
	TotalMeisToday: "Total de MEIs hoje",
	MEIsOk: "MEIs em dia",
	TotalDasOverDue: "Total de DAS vencidos",
	TotalDasnOverDue: "Total de DASN entregues",
	TotalUsersYesterday: "Total de usuários ontem",
	TotalMeisYesterday: "Total de MEIs ontem",
	TotalUsersLastSevenDays: "Total de usuários nos últimos sete dias",
	TotalMeisLastSevenDays: "Total de MEIs nos últimos sete dias",
	TotalUsersLastThirtyDays: "Total de usuários nos últimos trinta dias",
	TotalMeisLastThirtyDays: "Total de MEIs nos últimos trinta dias",
	tag: "Tag",
	activeDebt: "Dívida ativa",
	inInstallments: "Em parcelamento",
	Sent: "Enviado",
	Delivered: "Entregue",
	Read: "Lido",
	LinkOpened: "Link aberto",
	Cancelled: "Cancelado"
};

export default strings;
